<script setup lang="ts">
defineProps<{
	type?: 'button' | 'submit'
	variant?: 'danger' | 'success'
	disabled?: boolean
	href?: string
}>()
</script>

<template>
	<a
		v-if="href"
		:href="href"
		:class="['c-button', variant && `c-button--${variant}`]"
	>
		<slot />
	</a>
	<button
		v-else
		:type="type ?? 'button'"
		:disabled="disabled"
		:class="['c-button', variant && `c-button--${variant}`]"
	>
		<slot />
	</button>
</template>
